import { useAuth0 } from '@auth0/auth0-react';

import '../css_styles/button_styles.css'
import background_img from './images/Aixelo_Background Graphic_Wave.png';
import logo from './images/LogoWhite.png';

function LoginPage(props) {

    const { loginWithRedirect, isAuthenticated} = useAuth0();

    return (
        !isAuthenticated && (
            <div style={{ overflow: 'hidden', width: '100vw', height: '100vh' }}>
                <img style={{ 
                            width: '100%', 
                            height: '100%', 
                            objectFit: 'cover' 
                    }} 
                    src={background_img} alt="background"/>
                <img style={{ 
                            position: 'absolute',
                            width: '250px',
                            top: '50px', 
                            left: '50%', 
                            transform: 'translateX(-50%)', 
                            zIndex: 1 
                    }} 
                    src={logo} alt="logo"/>
                <div style={{ 
                            position: 'absolute',
                            width: '100%',
                            color: 'white',
                            fontSize: '40px',
                            top: '180px', 
                            zIndex: 1,
                            textAlign: 'center'
                    }} 
                >
                    Welcome to <span style={{color: 'var(--aixelo-green)',
                                             font: '40px "Raleway", sans-serif'
                    }}>Edison-4.0&#8482;</span>
                </div>
                <button 
                    className='loginButton'
                    style={{ 
                        position: 'absolute', 
                        top: '250px', 
                        left: '50%', 
                        transform: 'translate(-50%)', 
                        zIndex: 1 
                    }}
                    onClick={() => loginWithRedirect()}>
                    Proceed to Login
                </button>
            </div>
        )
    )
}

export default LoginPage
